import { Box, Stack } from '@mui/material';
import { AttendanceCode } from '@schooly/api';
import { FC } from 'react';

import { AttendanceCodeCircle } from './AttendanceCodeCircle';

type AttendanceCodeCircleGroupProps = {
  codes: (AttendanceCode | null)[];
  size?: number;
};

export const AttendanceCodeCircleGroup: FC<AttendanceCodeCircleGroupProps> = ({ codes, size }) => (
  <Stack direction="row" alignItems="center" flexShrink={0}>
    {codes.map((code, index) => (
      <Box
        key={code?.id ?? index}
        sx={(theme) => ({
          position: 'relative',
          zIndex: codes.length - index,
          borderRadius: '50%',
          boxShadow: `0 0 0 1px ${theme.palette.background.paper}`,
          ...(index && { ml: -0.75 }),
        })}
      >
        <AttendanceCodeCircle code={code ?? undefined} size={size} />
      </Box>
    ))}
  </Stack>
);
